export const categories = [
  {
    id: 1,
    img: "https://th.bing.com/th/id/OIP.r-XyHSkwoS8ak2HnV82zXAHaLG?w=203&h=304&c=7&r=0&o=5&dpr=1.3&pid=1.7",
    title: "GYM CLOTHES!",
    cat: "fashion",
  },
  {
    id: 2,
    img: "https://th.bing.com/th/id/OIP.7YkZfjSQnYN2gXY6UUI0vgHaFj?w=248&h=186&c=7&r=0&o=5&dpr=1.3&pid=1.7",
    title: "WORKOUT EQUIPMENTS",
    cat: "equipment",
  },
  {
    id: 3,

    img: "https://th.bing.com/th/id/OIP.3jFHE3yDAnnfi0TZmTVolwHaE2?w=272&h=180&c=7&r=0&o=5&dpr=1.3&pid=1.7",
    title: "SUPPLIMENTS",
    cat: "suppliment",
  },
];

export const popularProducts = [
  {
    id: 1,
    img: "https://i.pinimg.com/originals/15/bd/a5/15bda537909a0925495a08e950500758.jpg",
  },
  {
    id: 2,
    img: "https://th.bing.com/th/id/OIP.YRCclWvPZr0WkkjJ1e3PWAHaHa?w=193&h=193&c=7&r=0&o=5&dpr=1.3&pid=1.7",
  },
  {
    id: 3,
    img: "https://th.bing.com/th/id/OIP._hGlpX_BC-t2FVOU6B3ULwHaJ4?w=203&h=271&c=7&r=0&o=5&dpr=1.3&pid=1.7",
  },
  {
    id: 4,
    img: "https://th.bing.com/th/id/OIP.ddvCG7KWSKHQtqLYVnFPrQHaHa?w=203&h=203&c=7&r=0&o=5&dpr=1.3&pid=1.7",
  },
  {
    id: 5,
    img: "https://th.bing.com/th/id/OIP.nHfUzhk_01RvRvuO81JeTwHaLG?pid=ImgDet&rs=1",
  },
  {
    id: 6,
    img: "https://th.bing.com/th/id/OIP.i_vzjTxx65sj4kXyI3FErAHaHa?w=194&h=194&c=7&r=0&o=5&dpr=1.3&pid=1.7",
  },
  {
    id: 7,
    img: "https://th.bing.com/th/id/OIP.YQX3TPVbv8yUA_KFn0qKqgHaHa?w=210&h=210&c=7&r=0&o=5&dpr=1.3&pid=1.7",
  },
  {
    id: 8,
    img: "https://th.bing.com/th/id/OIP.dZpXqjGf64mWvelQs17NqAHaJq?w=186&h=243&c=7&r=0&o=5&dpr=1.3&pid=1.7",
  },
];
